import React, { useContext, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import CategoryHome from "../../Components/Categories/CategoryHome";
import ArticleSearch from "../../Components/ArticleSearch/ArticleSearch";
import LegacyArticleSearch from "../../Components/Legacy/LegacyArticleSearch";
import { KBContext, AutherContext, SearchContext } from "../../Context";
import Layout from "../../Components/Layout";
import LegacyLayout from "../../Components/Legacy/LegacyLayout";
import LegacyCategoryHome from "../../Components/Legacy/LegacyCategoryHome";
import { NewCategoryLoader } from "../../Components/Loaders/NewCategoryLoader";
import { handleGainSightEventForPageNotFound } from "../../gainSightIntegration";
import useNavigateWithSearch from "../../Context/KBContext/hooks/useNavigateWithSearch";
import { isFeatureEnabled, isNewUIEnabled } from "../../utils";
import { FTR_KB_AI_SEARCH } from "../../Constants";
import { clearLocalStoragePreserving } from "../../Constants/LocalStorage";

export default function Categories() {
  const navigate = useNavigateWithSearch();
  const [searchParams, setSearchParams] = useSearchParams();
  const { data, availableFeatures } = useContext(KBContext);
  const { searchList, searchInput } = useContext(SearchContext);
  const { isInternal } = data;
  const { redirectToken, hasPermission } = useContext(AutherContext);
  const isNewUI = isNewUIEnabled(availableFeatures);
  const isAISearchEnabled = isFeatureEnabled(FTR_KB_AI_SEARCH, availableFeatures);

  useEffect(() => {
    if (searchParams.has("q")) {
      const next = new URLSearchParams(searchParams);
      next.delete("q");
      setSearchParams(next, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- run once on mount to strip leftover q
  }, []);

  const showCategories = () => {
    if (isInternal !== undefined && !isInternal) {
      return true;
    } else {
      return hasPermission;
    }
  }

  useEffect(() => {
    if (!data) {
      handleGainSightEventForPageNotFound(window.location.href);
      navigate("/not-found");
    }
  }, [data, navigate]);

  useEffect(() => {
    if (!redirectToken && isInternal && !hasPermission) {
      clearLocalStoragePreserving();
      navigate("/login");
    }
  }, [isInternal, hasPermission, redirectToken, navigate]);

  if (showCategories() && Object.keys(data).length > 0) {
    const LayoutComponent = isNewUI ? Layout : LegacyLayout;
    const CategoryHomeComponent = isNewUI ? CategoryHome : LegacyCategoryHome;
    const ArticleSearchComponent = isNewUI ? ArticleSearch : LegacyArticleSearch;
    /* FF on: similar articles in dropdown only. FF off: full-page ArticleSearch (hiver-website-old). */
    const showArticleSearchResults =
      !isAISearchEnabled && searchInput?.length > 0 && searchList;
    return (
      <>
        <LayoutComponent>
          {showArticleSearchResults ? (
            <ArticleSearchComponent />
          ) : (
            <CategoryHomeComponent />
          )}
        </LayoutComponent>
      </>
    );
  } else {
    return <NewCategoryLoader />;
  }
}
